import { API_Data_Genres_Response } from "@/interfaces/api/genres/api_response_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

/*
==================
      GENRES
==================
*/

/**
 * Retrieves the genres from the server
 * 
 * @returns An array of genres.
 * @throws {API_Error} If the request fails or the response is invalid.
 */
export async function getGenres(locale: string): Promise<API_Data_Genres_Response> {
  const res = await fetcher(`/api/genres?lang=${locale}`, {
    method: 'GET'
  })
  const response = await res.json() as API_Response<API_Data_Genres_Response>
    
  if (!res.ok) throw { code: res.status, description: 'Unknow genre error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Genre data missing in response' } as API_Error

  return response.data
}